import React from "react";
import { Typography, Box } from "@mui/material";
import { motion } from "framer-motion";

const Location = ({ doctor }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
    >
      <Box sx={{ marginBottom: "1.5rem" }}>
        <motion.div
          whileHover={{ scale: 1.02 }}
          transition={{ type: "spring", stiffness: 200 }}
        >
          <Typography color="primary" gutterBottom>
            {doctor.clinicname}
          </Typography>
          <Typography color="textSecondary">{doctor.Address}</Typography>
        </motion.div>
      </Box>

      <motion.div
        initial={{ scale: 0.95, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ duration: 0.6 }}
      >
        <iframe
          width="100%"
          height="250"
          frameborder="0"
          scrolling="no"
          marginheight="0"
          marginwidth="0"
          style={{
            borderRadius: "10px",
            boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
          }}
          title={`${doctor.clinicname} Location`}
          allowFullScreen
          src="https://maps.google.com/maps?width=100%25&amp;height=400&amp;hl=en&amp;q=200%201st%20St%20SW,%20Rochester,%20MN%2055905,%20United%20States+(Mayo%20Clinic)&amp;t=&amp;z=14&amp;ie=UTF8&amp;iwloc=B&amp;output=embed"
        >
          <a href="https://www.gps.ie/">gps tracker sport</a>
        </iframe>
      </motion.div>
    </motion.div>
  );
};

export default Location;
